import { render, staticRenderFns } from "./Smart.vue?vue&type=template&id=bec8ebce&scoped=true&"
import script from "./Smart.vue?vue&type=script&lang=js&"
export * from "./Smart.vue?vue&type=script&lang=js&"
import style0 from "./Smart.vue?vue&type=style&index=0&id=bec8ebce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec8ebce",
  null
  
)

export default component.exports